module.exports = __webpack_public_path__ + "img/icon13.856bf136.856bf136.svg";